exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".noAccess {\n  position: absolute;\n  top: 90px;\n  color: #ffffff;\n  left: 300px;\n}", ""]);

